import { L } from '@lib';
import { Select } from 'antd';
import { DefaultOptionType } from 'antd/lib/select';
import React, { memo } from 'react';

const { Option } = Select;

interface IProps {
  mode?: 'multiple';
  value?: string | string[];
  size?: 'small' | 'middle' | 'large';
  style?: React.CSSProperties;
  onChange?: ((value: any, option: DefaultOptionType | DefaultOptionType[] | undefined) => void) | undefined;
}

export const PaymentMethodSelect: React.FC<IProps> = memo(({ mode, value, size, style, onChange }) => {
  const isMultiple = mode === 'multiple';
  return (
    <Select
      mode={mode}
      style={{ width: 120, ...style }}
      allowClear={isMultiple}
      maxTagCount={isMultiple ? 'responsive' : undefined}
      placeholder={L('All')}
      value={value}
      size={size}
      onChange={onChange}
    >
      <Option value="Cash">{L('Cash')}</Option>
      <Option value="Card">{L('Card')}</Option>
      <Option value="OnlineCard">{L('Online card')}</Option>
      <Option value="BankTransfer">{L('Bank transfer')}</Option>
      <Option value="Other">{L('Other payment')}</Option>
    </Select>
  );
});
